import React from 'react'
import './styles/badge.scss'

const Badge = (props) => {
    const {
        children, cssClass, isRounded, type, style, label, icon, onClick,
    } = props

    let componentClass = 'uc-badge'
    componentClass += isRounded ? ' rounded' : ''
    componentClass += icon ? ' iconBadge' : ''
    componentClass += type ? ` ${type}` : ''
    componentClass += cssClass ? ` ${cssClass}` : ''
    componentClass += onClick ? ' link' : ''

    return (
        <span className={componentClass} style={style} onClick={onClick}>
            {label}
            {icon ? <i className={icon} /> : null}
            {children}
        </span>
    )
}

export default Badge
